/* Base */

.eds-chip {
  --eds--color--border-input-default: var(--eds--palette-gray-500);
  --_overlay-hover: linear-gradient(
    var(--eds--overlay-hover-default),
    var(--eds--overlay-hover-default)
  );
  align-items: center;
  appearance: none;
  background-color: var(--eds--color--bg-muted-default);
  background-image: linear-gradient(transparent, transparent);
  border: var(--eds--size-1) solid transparent;
  border-radius: var(--eds--radii-4);
  box-sizing: border-box;
  color: var(--eds--color--fg-default);
  cursor: default;
  display: inline-flex;
  flex-shrink: 1;
  font: inherit;
  gap: var(--eds--spacing-4);
  justify-content: center;
  line-height: var(--eds--typography--body-m-line-height);
  margin: 0;
  max-width: 240px;
  /* body-m line-height (20) + padding-2 top/bottom */
  min-height: calc(
    var(--eds--typography--body-m-line-height) + var(--eds--padding-2) +
      var(--eds--padding-2)
  );
  min-width: 0;
  overflow: hidden;
  padding: var(--eds--padding-2) var(--eds--padding-4);
  text-align: start;
  transition-duration: var(--eds--transition-duration-moderate);
  transition-property:
    background-color, background-image, border-color, box-shadow, color, opacity;
  transition-timing-function: ease-out;
  width: fit-content;
}

.eds-chip .eds-tooltip--trigger {
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
}

.eds-chip--icon {
  --eds--iconography-color: currentColor;
  display: inline-flex;
  flex-shrink: 0;
}

/* States */

.eds-chip--outlined {
  background-color: transparent;
  border-color: var(--eds--color--border-input-default);
}

/* Figma seats the trailing badge flush against the chip edge, so the chip drops
 * its block and trailing padding and the badge stretches to the chip height. */
.eds-chip--has-count {
  padding-block: 0;
  padding-inline-end: 0;
}

.eds-chip--trigger {
  cursor: pointer;
}

.eds-chip--dismissible {
  cursor: default;
  /* Let the dismiss hit target extend past the chip without being clipped. */
  overflow: visible;
}

/* Figma layers overlay/hover/default over the chip's own surface on both hover
 * and focus, so the tint composites instead of replacing the filled and
 * outlined backgrounds. */
.eds-chip--trigger:hover:not(:disabled):not(.eds-chip--disabled),
.eds-chip--trigger:focus-visible:not(:disabled):not(.eds-chip--disabled) {
  background-image: var(--_overlay-hover);
}

.eds-chip--trigger:focus-visible {
  box-shadow: var(--eds--interaction-focus-ring);
  outline: none;
}

.eds-chip--disabled,
.eds-chip:disabled {
  color: var(--eds--color--fg-disabled);
  cursor: not-allowed;
  opacity: var(--eds--opacity-disabled);
}

.eds-chip--disabled .eds-chip--dismiss {
  cursor: not-allowed;
}

/* Dismiss — only this control is interactive */

.eds-chip--dismiss {
  --_dismiss-hit-outset: calc((var(--eds--size-24) - var(--eds--size-16)) / 2);
  align-items: center;
  background: transparent;
  border: none;
  /* content-box: padding grows the hit target around the 16px icon box. */
  box-sizing: content-box;
  color: inherit;
  cursor: pointer;
  display: inline-flex;
  flex-shrink: 0;
  height: var(--eds--size-16);
  justify-content: center;
  /* Negative margin cancels padding so layout/visual size stay 16×16. */
  margin: calc(var(--_dismiss-hit-outset) * -1);
  padding: var(--_dismiss-hit-outset);
  width: var(--eds--size-16);
}

.eds-chip--dismiss:focus-visible {
  border-radius: var(--eds--radii-4);
  outline: 2px solid var(--eds--color--border-brand);
  outline-offset: 1px;
}
